import { render, staticRenderFns } from "./ToeflJuniorScoreComponent.vue?vue&type=template&id=829527fc&scoped=true&"
import script from "./ToeflJuniorScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflJuniorScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflJuniorScoreComponent.vue?vue&type=style&index=0&id=829527fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829527fc",
  null
  
)

export default component.exports